import { AirPressureIconGray } from '../../../../../../Icons/WeatherIcons/AirPressure/AirPressureIconGray';
import { MoonPhaseIcon } from '../../../../../../Icons/WeatherIcons/MoonPhase/MoonPhaseIcon';
import { TimeOfDayIconGray } from '../../../../../../Icons/WeatherIcons/SunPosition/TimeOfDayIconGray';
import { WaterTemperatureIconGray } from '../../../../../../Icons/WeatherIcons/WaterTemperature/WaterTemperatureIconGray';
import { WeatherConditionIconGrey } from '../../../../../../Icons/WeatherIcons/WeatherCondition/WeatherConditionIconGrey';
import { WindIcon } from '../../../../../../WindIcon/WindIcon';
import { iconsSize } from '../iconsSize';

export const catchesInfoCardsData = [
  {
    id: '1',
    bottomText: 'Weather',
    iconComponent: <WeatherConditionIconGrey height={iconsSize} width={iconsSize} />,
  },
  {
    id: '2',
    bottomText: 'Water temperature',
    iconComponent: <WaterTemperatureIconGray height={iconsSize} width={iconsSize} />,
  },
  {
    id: '3',
    bottomText: 'Wind',
    iconComponent: <WindIcon angle={250} height={iconsSize} width={iconsSize} />,
  },
  {
    id: '4',
    bottomText: 'Time of day',
    iconComponent: <TimeOfDayIconGray height={iconsSize} width={iconsSize} />,
  },
  {
    id: '5',
    bottomText: 'Moon phase',
    iconComponent: <MoonPhaseIcon moonPhase="third_quarter" height={iconsSize} width={iconsSize} />,
  },
  {
    id: '6',
    bottomText: 'Air pressure',
    iconComponent: <AirPressureIconGray height={iconsSize} width={iconsSize} />,
  },
];
